import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-delete-recurrent-shift-modal',
  templateUrl: './delete-recurrent-shift-modal.component.html',
  styleUrls: ['./delete-recurrent-shift-modal.component.scss'],
})
export class DeleteRecurrentShiftModalComponent implements OnInit {

  @Input() data :{
    headerText: string,
    messageText: string,
    buttonText: string,
  
  } 


  ngOnInit(): void {

  }

  constructor(
    private modalController: ModalController,

  ) { }

  async onSave() {
    this.modalController.dismiss(true);
  }

  dismiss() {
    this.modalController.dismiss();
  }



}
